import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "resources/css/font/font.css";
import "resources/css/styles.css";
import "../src/routes/styles.css";
import { useContext, useState } from "react"

import Header from "routes/header/Header";
import Main5 from "routes/puffu/Main5";
import Company from "routes/Company/Company.js";
import Renewal from "routes/renewal/Renewal.js";



function App() {

  const [slideDirection, setSlideDirection] =useState(null);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [activeSlideCurrent, setActiveslideCurrent] = useState(null);

  return (
    <>
      <Router>
        {/* <Header direction={slideDirection} isLastSlide={isLastSlide} activeSlideCurrent={activeSlideCurrent} /> */}
        <Routes>
          {/* <Route path="/" element={<Main5 onslideChange={setSlideDirection} activeSlideCurrent={setActiveslideCurrent} />} /> */}
          <Route path="/" element={<Renewal />} />
          <Route path="/Company" element={<Company onslideChange={setSlideDirection} onLastSlide={setIsLastSlide} />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
